export const DATE_INVALID_FORMAT_ERROR = 'Неверный формат даты'
export const DATE_FUTURE_ERROR = 'Дата не может быть в будущем'

const isValidCalendarDate = (day: number, month: number, year: number) => {
  const date = new Date(year, month - 1, day)

  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
}

const formatDate = (date: Date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}

/** Валидация даты в формате ISO (yyyy-mm-dd) */
export const validateIsoDate = (
  isoDate: string,
  options: { noFutureDate?: boolean } = {}
): string | null => {
  const [year, month, day] = isoDate.split('-')

  if (
    !year ||
    !month ||
    !day ||
    year.length !== 4 ||
    month.length !== 2 ||
    day.length !== 2 ||
    !isValidCalendarDate(Number(day), Number(month), Number(year))
  ) {
    return DATE_INVALID_FORMAT_ERROR
  }

  if (options.noFutureDate && isoDate > formatDate(new Date())) {
    return DATE_FUTURE_ERROR
  }

  return null
}
